import axios, { AxiosResponse } from 'axios'
import { IFeedbackValues, IFeedbackResponse } from '~/interfaces'
const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const sendFeedback = async (values: IFeedbackValues): Promise<IFeedbackResponse> => {
  const response = await axios.post(`${hstoryAPI}/user-feedback`, values)
  const { data }: AxiosResponse<IFeedbackResponse> = response
  return data
}
